<script>
    import { onMount } from "svelte";
    import { _ } from "svelte-i18n";

    let observerCallback = function(entries, observer) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          intersected = true;
          observer.unobserve(imgElement);
        }
      });
    };
    export let placeholder;
    export let src;
    export let alt;
    export let classes="shadow-lg w-80 rounded-lg mx-auto self-center";
    let imgElement;
    let path;
    let observer;
    let intersected = false;
    let loaded = false;
    $: path = intersected ? src : placeholder;
    onMount(() => {
      observer = new IntersectionObserver(observerCallback)
      observer.observe(imgElement);
      return () => {
        observer.unobserve(imgElement);
      };
    });
    function handleLoad() {
      if (!loaded && path === src) {
        loaded = true;
      }
    }
  </script>
  
  <img
    src={path}
  alt="{$_('lazyImage.placeholder')}"
    on:load={handleLoad}
    bind:this={imgElement}
    class="{classes}
    {loaded?'':'animate-pulse'}
    "
  />